import { TableContainer, ITableStructure } from '../../../base';
import { TableIds } from '../../../common';
import { useTableCells } from './hooks/useTableCells';
import { useTableCallbacks } from './hooks/useTableCallbacks';

const DashboardJobsTable = () => {
    const cells = useTableCells();
    const { onRowClick } = useTableCallbacks();

    const callbacks = {
        onRowClick,
    };

    const tableStructure: ITableStructure = {
        id: TableIds.DASHBOARD_JOBS,
        cells,
        filters: [],
        noTopActions: true,
        tableHeight: 297,
    };

    return <TableContainer structure={tableStructure} callbacks={callbacks} />;
};
export default DashboardJobsTable;
